import styled from "styled-components";

export const Main = styled.main`
  margin: 0 auto;
  margin-top: 100px;
  margin-bottom : 60px;
  width: 1130px;
  @media (max-width: 425px){
    width: 100vw;
    margin-top: 64px;
    }
`;